import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSmartcar = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsxs("g", {
			clipPath: "url(#clip0_119_118)",
			children: [/* @__PURE__ */ _jsx("path", {
				d: "M5.8281 9.07609C5.46936 9.07609 5.22953 8.70971 5.40313 8.39577C6.68769 6.07269 9.17022 4.48913 12 4.48913C14.8283 4.48913 17.2785 6.0715 18.5549 8.39595C18.7275 8.71018 18.4875 9.07609 18.1291 9.07609H5.8281ZM4.54051 12.8794C4.50581 12.5845 4.75528 12.3395 5.04795 12.39C7.70919 12.8486 9.86986 15.3705 10.2951 18.6474C10.3379 18.9767 10.0335 19.2346 9.7172 19.1334C6.95878 18.2511 4.88756 15.8294 4.54051 12.8794ZM14.2828 19.1334C13.9665 19.2346 13.6621 18.9767 13.7049 18.6474C14.1301 15.3705 16.2908 12.8486 18.9521 12.39C19.2447 12.3395 19.4942 12.5845 19.4595 12.8795C19.1124 15.8294 17.0412 18.2511 14.2828 19.1334ZM12 1.25C6.06339 1.25 1.25 6.06339 1.25 12C1.25 17.9366 6.06339 22.75 12 22.75C17.9366 22.75 22.75 17.9366 22.75 12C22.75 6.06339 17.9366 1.25 12 1.25Z",
				fill: "#DBE4E8",
				stroke: "#293235"
			}), /* @__PURE__ */ _jsx("path", {
				d: "M11.9997 14.1736C12.72 14.1736 13.304 13.5896 13.304 12.8693C13.304 12.1489 12.72 11.5649 11.9997 11.5649C11.2793 11.5649 10.6953 12.1489 10.6953 12.8693C10.6953 13.5896 11.2793 14.1736 11.9997 14.1736Z",
				fill: "#DBE4E8",
				stroke: "#293235"
			})]
		}),
		/* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
			id: "clip0_119_118",
			children: /* @__PURE__ */ _jsx("rect", {
				width: 24,
				height: 24,
				fill: "white"
			})
		}) })
	]
});
const ForwardRef = forwardRef(SvgSmartcar);
export { ForwardRef as ReactComponent };
